import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LabelComponent } from '../../../../../osp-ui/components/form/form-field/components/label/label.component';
import { FormFieldComponent } from '../../../../../osp-ui/components/form/form-field/form-field.component';
import { SliderComponent } from '../../../../../osp-ui/components/form/slider/slider.component';
import { AlarmSettingsFieldData } from '../../../contract/alarm-settings-field-data.contract';
import { AlarmSettingsUtilsService } from '../../../services/alarm-settings-utils.service';
import { AlarmSettingsBase } from '../alarm-settings-base.class';
import { AlarmSettingsFormControls } from '../contract/alarm-settings-form-controls.contract';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, SliderComponent, FormFieldComponent, LabelComponent],
  selector: 'osp-limit-percentage-settings',
  templateUrl: './limit-percentage-settings.component.html',
})
export class LimitPercentageSettingsComponent extends AlarmSettingsBase implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() set form(form: FormGroup<AlarmSettingsFormControls>) {
    this.settingsForm = form;
  }

  @Input() set fieldData(fieldData: AlarmSettingsFieldData) {
    this.alarmSettingsFieldData = fieldData;
  }

  protected settingsLimitPercentageLabel = '';
  protected settingsLimitPercentageExplanation: string = '';

  constructor(private alarmSettingsUtilsService: AlarmSettingsUtilsService) {
    super();
  }

  public ngOnInit(): void {
    this.subscribeToAlarmTypeChanges();
    this.setExplanations();
    this.setLabels();
  }

  public formatLabel(value: number): string {
    return `${value}%`;
  }

  private setDefaultValue(): void {
    this.limitControl?.setValue(this.limitControl && this.limitControl.value ? this.limitControl.value : 0);
  }

  private subscribeToAlarmTypeChanges(): void {
    this.alarmSettingsUtilsService.alarmTypeChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.setDefaultValue());
  }

  private setExplanations(): void {
    this.settingsLimitPercentageExplanation = this.getFieldTooltipText(this.controlNames.SETTINGS_LIMIT);
  }

  private setLabels(): void {
    this.settingsLimitPercentageLabel = this.getFieldLabel(this.controlNames.SETTINGS_LIMIT);
  }
}
